const uiColors = {
  overlay: {
    default: 'rgba(4, 0, 29, 0.9)',
  },
  primary: {
    default: 'rgba(5, 180, 255, 0.5)',
    hover: 'rgba(94, 207, 255, 0.7)',
    pressed: 'rgba(0, 124, 177, 0.5)',
    disabled: 'rgba(5, 180, 255, 0.2)',
  },
  secondary: {
    default: '#FF2F6D',
    hover: '#FF6594',
    pressed: '#E20749',
  },
  toggled: {
    default: 'rgba(94, 207, 255, 0.7)',
  }
};

const uiConfig = {
  H: {
    colors: uiColors,
    offsets: {
      right_panel: { top: 0, left: -11 },
      bottom_panel: { top: -48, left: 0 },
      tournaments_panel: { top: 0, left: 0 }
    },
  },
  V: {
    colors: uiColors,
    offsets: {
      top: 0,
      left: 0,
      tournaments_panel: { top: -160, left: -580 }
    },
  }
};

export {
  uiConfig,
}
